import {
  Button,
  DialogBody,
  DialogFooter,
  Typography,
} from "@suraasa/placebo-ui"
import clsx from "clsx"
import { useState } from "react"

import DragNDropFile from "@/features/home/component/drag-n-drop-csv"

import { UploadedTeacherData } from "./constants"

const ErrorState = ({
  title,
  description,
  className,
}: {
  title: string
  description: React.ReactNode | string
  className?: string
}) => {
  return (
    <div
      className={clsx(
        "rounded-md border border-critical-200 bg-critical-50 p-2",
        className,
      )}
    >
      <Typography
        variant="strongSmallBody"
        className="mb-0.5 text-critical-500"
      >
        {title}
      </Typography>
      {typeof description === "string" ? (
        <Typography className="text-onSurface-700" variant="smallBody">
          {description}
        </Typography>
      ) : (
        description
      )}
    </div>
  )
}

const UploadState = ({
  sheetData,
  onClickContinue,
  onUpdateSheetData,
  files,
  setFiles,
}: {
  sheetData: UploadedTeacherData[]
  onClickContinue: () => void
  onUpdateSheetData: (data: UploadedTeacherData[]) => void
  files: string | FileList | null
  setFiles: (f: string | FileList | null) => void
}) => {
  const [error, setErrors] = useState<{
    title: string
    description: React.ReactNode | string
  } | null>(null)

  return (
    <>
      <DialogBody className="p-2.5">
        <div>
          {/* <SeatsAvailable seats={[40]} className="mb-2 w-fit" /> */}
          <Typography className="mb-2">
            Format your CSV file according to this{" "}
            <a
              href="https://docs.google.com/spreadsheets/d/1vk7SKMYKsYf2d73vfinKJJ0dRI9V0I91Vt8tRp-sifc/edit?usp=sharing"
              className="text-strong text-primary-500 underline underline-offset-4"
              target="_blank"
            >
              template.
            </a>
          </Typography>
          <DragNDropFile
            onChange={(data) => {
              onUpdateSheetData(data)
            }}
            resetError={() => {
              setErrors(null)
            }}
            onError={(err) => {
              setErrors(err)
            }}
            files={files}
            setFiles={setFiles}
          />
          {error && <ErrorState {...error} className="mt-2.5" />}
        </div>
      </DialogBody>
      <DialogFooter>
        <Button
          onClick={onClickContinue}
          disabled={sheetData.length === 0}
          color="black"
          size="sm"
          className="rounded-xl"
        >
          Continue
        </Button>
      </DialogFooter>
    </>
  )
}

export default UploadState
